export default (function (_ref) {
  var colors = _ref.colors,
      fonts = _ref.fonts;
  return {
    /** Targets the tooltip arrow when placement is set to `bottom`. */
    arrowPlacementBottom: {
      '&::before': {
        borderBottom: "6px solid ".concat(colors.darkGrey),
        borderLeft: "6px solid ".concat(colors.transparent, " !important"),
        borderRight: "6px solid ".concat(colors.transparent, " !important"),
        bottom: '100%',
        left: '50%',
        transform: 'translateX(-50%)'
      }
    },

    /** Targets the tooltip arrow when placement is set to `left`. */
    arrowPlacementLeft: {
      '&::before': {
        borderBottom: "6px solid ".concat(colors.transparent, " !important"),
        borderLeft: "6px solid ".concat(colors.darkGrey),
        borderTop: "6px solid ".concat(colors.transparent, " !important"),
        bottom: '50%',
        left: '100%',
        transform: 'translateY(50%)'
      }
    },

    /** Targets the tooltip arrow when placement is set to `right`. */
    arrowPlacementRight: {
      '&::before': {
        borderBottom: "6px solid ".concat(colors.transparent, " !important"),
        borderRight: "6px solid ".concat(colors.darkGrey),
        borderTop: "6px solid ".concat(colors.transparent, " !important"),
        bottom: '50%',
        right: '100%',
        transform: 'translateY(50%)'
      }
    },

    /** Targets the tooltip arrow when placement is set to `top`. */
    arrowPlacementTop: {
      '&::before': {
        borderLeft: "6px solid ".concat(colors.transparent, " !important"),
        borderRight: "6px solid ".concat(colors.transparent, " !important"),
        borderTop: "6px solid ".concat(colors.darkGrey),
        left: '50%',
        top: '100%',
        transform: 'translateX(-50%)'
      }
    },

    /** Maps to MuiTooltip.popper */
    popper: {
      zIndex: 2000
    },

    /** Maps to MuiTooltip.tooltip */
    tooltip: {
      backgroundColor: colors.darkGrey,
      borderRadius: '3px',
      color: colors.white,
      fontFamily: fonts["default"],
      fontSize: 12,
      padding: '6px 8px'
    },

    /** Targets the tooltip arrow and applies style regardless of tooltip placement. */
    tooltipArrow: {
      '::before': {
        content: '""',
        margin: 'auto',
        position: 'absolute'
      }
    },

    /** Maps to MuiTooltip.tooltipPlacementBottom */
    tooltipPlacementBottom: {
      margin: '8px 0'
    },

    /** Maps to MuiTooltip.tooltipPlacementLeft */
    tooltipPlacementLeft: {
      margin: '0 8px'
    },

    /** Maps to MuiTooltip.tooltipPlacementRight */
    tooltipPlacementRight: {
      margin: '0 8px'
    },

    /** Maps to MuiTooltip.tooltipPlacementTop */
    tooltipPlacementTop: {
      margin: '8px 0'
    },

    /** Targets tooltip for type `action`. */
    tooltipTypeAction: {
      backgroundColor: colors.adminBlue,
      '&::before': {
        borderColor: colors.adminBlue
      }
    },

    /** Targets tooltip for type `error`. */
    tooltipTypeError: {
      backgroundColor: colors.errorRed,
      '&::before': {
        borderColor: colors.errorRed
      }
    },

    /** Targets tooltip for type `success`. */
    tooltipTypeSuccess: {
      backgroundColor: colors.nikeFuel,
      '&::before': {
        borderColor: colors.nikeFuel
      }
    },

    /** Targets tooltip for type `warning`. */
    tooltipTypeWarning: {
      backgroundColor: colors.laserOrange,
      '&::before': {
        borderColor: colors.laserOrange
      }
    },

    /** Maps to MuiTooltip.touch */
    touch: {}
  };
});